<template>
  <div
    id="sidebar"
    ref="sidebar"
    :class="rwdMenu ? 'sidebar rwdSidevar' : 'sidebar'"
  >
    <!-- background-color="#2a3f54"
      text-color="#fff"
      active-text-color="#999" 
      之前的顏色
      -->
    <el-menu
      @select="handleSelect"
      class="sidebar-el-menu"
      unique-opened
      :default-active="onRoutes"
      :collapse="collapse"
      background-color="#32688c"
      text-color="#fff"
      active-text-color="#ffd04b"
      router
    >
      <div
        class="d-flex justify-content-center align-items-center"
        style="border-bottom:1px solid #d4d4d4;"
      >
        <div
          style="width: 50px; height: 50px; padding:5px; flex:1; "
        ></div>
        <!-- <el-image
          style="width: 50px; height: 50px; flex:1;"
          src="https://png.pngtree.com/png-clipart/20190520/original/pngtree-hand-painted-japanese-flag-with-calligraphic-brushes-png-image_4145655.jpg"
        ></el-image> -->
        <div style="margin-left:auto;">
          <button
            @click="
              rwdMenu = !rwdMenu;
              $bus.$emit('sidebar', rwdMenu);
            "
            :class="{ 'is-active': true }"
            :title="$t('Theme.closeSidebar')"
            class="hamburger hamburger--squeeze d-md-none"
            type="button"
          >
            <span class="hamburger-box">
              <span class="hamburger-inner"></span>
            </span>
          </button>
        </div>
      </div>
      <!-- <div
        :class="collapse ? 'd-none' : 'd-flex'"
        class="user border-bottom  justify-content-center align-items-center"
        style="height:80px;"
      >
        <el-image
          style="width: 50px;"
          class="pd-1 mr-3"
          src="https://cdn3.iconfinder.com/data/icons/avatars-round-flat/33/avat-01-512.png"
        ></el-image>
        <div>
          <span>Welcome,</span>
          <h2>{{ userAccount() }}</h2>
        </div>
      </div> -->
      <MenuTree :menuData="this.routeList"></MenuTree>
    </el-menu>
  </div>
</template>

<script>
import elementResizeDetectorMaker from 'element-resize-detector';
import MenuTree from './components/MenuTree.vue';

export default {
  data() {
    return {
      collapse: false,
      routeList: [],
      rwdMenu: false,
    };
  },
  components: {
    MenuTree,
  },
  computed: {
    onRoutes() {
      return `/${this.$route.meta.url}`;
    },
  },
  methods: {
    userAccount() {
      const that = this;
      const user = JSON.parse(localStorage.getItem('userInfo') || '{}');
      return user.p3_account.p3_ant_account;
    },
    handleSelect(key, keyPath) {
      // 移動路徑的就清空 session Storage
      sessionStorage.clear();
    },
  },
  created() {
    this.routeList = JSON.parse(localStorage.getItem('NodeTree'));
  },
  mounted() {
    // elementResizeDetectorMaker 監聽視窗套件
    const erd = elementResizeDetectorMaker();
    erd.listenTo(document.getElementById('sidebar'), (element) => {
      const width = element.offsetWidth;
      const height = element.offsetHeight;
      this.$nextTick(() => {
        this.$store.dispatch('setWidth', width);
      });
    });

    // 接收bus 傳過來的值
    this.$bus.$on('sidebar', (params) => {
      this.rwdMenu = params;
    });
    this.$bus.$on('PC_sidebar', (params) => {
      this.collapse = params;
    });
  },
};
</script>



<style lang="scss">
$icon: #3d3d3d;
$gray: #5b5b5b;
$gold: #fff;
.el-menu.el-menu--inline {
  li {
    min-width: 178px;
  }
}
// 在collapse為 true時 裡面的 i span a 都變更
.el-submenu__title,
.el-menu-item {
  i {
    color: $gold !important;
  }
  span {
    font-size: 0.9rem;
    letter-spacing: 1px;
  }
  a {
    font-size: 0.9rem;
    letter-spacing: 1px;
    color: $gold;
    text-decoration: none;
  }
}
.sidebar {
  @media all and (max-width: 767px) {
    width: 100% !important;
  }
  i {
    color: $gold;
  }
  span {
    font-size: 0.9rem;
    letter-spacing: 1px;
  }
  a {
    font-size: 0.9rem;
    letter-spacing: 1px;
    color: $gold;
    text-decoration: none;
  }
  .el-icon-arrow-down {
    color: $gold;
  }
  .el-menu-item {
  }
  .el-menu-item:hover {
    background-color: #282828 !important;
    cursor: pointer;

    // a {
    //   color: #ebe5e5;
    // }
  }
  // 這裡collapse為true時將 字跟 > 給隱藏起來
  .el-menu--collapse {
    span {
      font-size: 0px;
    }
    .el-submenu__icon-arrow {
      display: none;
    }
  }
}
.sidebar-el-menu:not(.el-menu--collapse) {
  min-width: 230px;
  // width: $sidebar-width;
}
</style>


<style lang="scss" scoped>
$icon: #3d3d3d;
$gray: #5b5b5b;
$gold: #facf55;
//小平板
@mixin sm() {
  @media all and (min-width: 768px) and (max-width: 1119px) {
    @content;
  }
}
//手機
@mixin xs() {
  @media all and (max-width: 767px) {
    @content;
  }
}
// 直立手機
@mixin portrait() {
  @media screen and (orientation: portrait) and (max-width: 480px) {
    @content;
  }
}
.rwdSidevar {
  @media all and (max-width: 767px) {
    display: block !important;
    z-index: 99;
    ul {
      animation-name: sidebarMove;
      animation-duration: 0.3s;
      width: 100%;
    }
  }
}
@keyframes sidebarMove {
  0% {
    width: 0%;
  }
  100% {
    width: 100%;
  }
}

.sidebar {
  // 點開的狀態

  .user {
    @media all and (max-width: 767px) {
      display: none;
    }
    span {
      font-size: 13px;
      line-height: 30px;
      color: #bab8b8;
    }
    h2 {
      font-size: 14px;
      color: #ecf0f1;
      font-weight: 300;
    }
  }
  color: #fff;
  // width: 100%;
  font-family: 'Helvetica Neue', Helvetica, 'PingFang SC', 'Hiragino Sans GB',
    'Microsoft YaHei', '微软雅黑', Arial, sans-serif;
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  overflow-y: scroll;
  -ms-overflow-style: none; /* IE 11 */
  scrollbar-width: none; /* Firefox 64 */
  // 忘記什麼原因要 hidden
  // overflow: hidden;
  @media all and (max-width: 767px) {
    display: none;
  }
}

.sidebar::-webkit-scrollbar {
  width: 0;
}

.sidebar > ul {
  height: 100%;
}
.logo {
  -webkit-transition: min-width 0.3s ease-in-out;
  transition: min-width 0.3s ease-in-out;
  // min-width: calc(#{$sidebar-width} - 1px);
  display: inline-block;
  border-bottom: 1px solid $icon;
  background-position: center center;
  background-size: 80%;
  background-repeat: no-repeat;
  background-color: $icon;
  @include xs {
    display: none;
  }
  &:hover {
    // background-color: $iconHover;
  }
  a {
    display: block;
    height: 100%;
  }
}
</style>

<style lang="scss" src="./style/hamburgers/hamburgers.scss">
</style>

<style lang="scss" src="./style/_style.scss">
</style>


